<template>
    <div id="newAppVersion">
        <h1>{{ $t('new_app_version_' + device) }}</h1>
        <img src="./media/new-version.png"> 
    </div>
</template>
<script>
export default {
    name: 'NewAppVersion',
    data() {
        return {
            device: process.env.VUE_APP_DEVICE
        };
    }
}
</script>
<style lang="scss" scoped>
    #newAppVersion {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding: 0px 15px;

        h1 {
            font-size: 35px;

            @media only screen and (max-width: 768px) {
                font-size: 20px;
            }
        }
    
        img {
            width: 100%;
            max-width: 800px;
        }
    }
</style>
